<div class="encuesta-invitacion">
  <div class="encuesta-invitacion__header">
    <mat-icon fontSet="material-symbols-outlined" class="encuesta-invitacion__icon">rate_review</mat-icon>
    <h2 class="encuesta-invitacion__title">{{ 'encuesta_satisfaccion' | translate }}</h2>
  </div>

  <p class="encuesta-invitacion__text">
    {{ 'invitacion_encuesta' | translate }}
  </p>
  <p class="encuesta-invitacion__sub">{{ 'invitacion_encuesta_sub' | translate }}</p>

  <div class="encuesta-invitacion__actions">
    <button mat-button type="button" class="btn-later" (click)="masTarde()">
      {{ 'mas_tarde' | translate }}
    </button>
    <button mat-flat-button color="primary" type="button" (click)="responderAhora()">
      {{ 'responder_ahora' | translate }}
    </button>
  </div>
</div>
